import React, { Component } from 'react';
import ReactDOM from "react-dom";
import DesktopBreakpoint from './responsive_utilities/desktop_breakpoint';
import TabletBreakpoint from './responsive_utilities/tablet_breakpoint';
import PhoneBreakpoint from './responsive_utilities/phone_breakpoint';
import SmallPhoneBreakpoint from './responsive_utilities/small_phone_breakpoint';

import '../../../node_modules/react-vis/dist/style.css';
import {XYPlot, XAxis, YAxis, HorizontalGridLines, VerticalBarSeries, VerticalBarSeriesCanvas} from 'react-vis';
 
//const baseUrl = 'http://localhost:5006/api/';

const baseUrl = 'http://gvm.itoperators.dk:5006/api/';

export default class Graph extends Component {
  static propTypes = {

  };

  state = {
    useCanvas: false,
    GVPowerDay: [],
    GVPowerWeek: [],
    GVPowerMonth: [],
    GVPowerYear: [],
    GVConsumerDay: [],
    GVConsumerWeek: [],
    GVConsumerMonth: [],
    GVConsumerYear: []
  }

  componentDidMount() {
    this.fetchAPIData();
    this.timerID = setInterval(
      () => this.fetchAPIData(),
      20000
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  fetchAPIData = async () => {

    let GVPowerDayCall = await fetch(baseUrl + 'GVM/1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPowerDay' }});    
    let GVPowerWeekCall = await fetch(baseUrl + 'GVM/1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPowerWeek' }});    
    let GVPowerMonthCall = await fetch(baseUrl + 'GVM/1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPowerMonth' }});    
    let GVPowerYearCall = await fetch(baseUrl + 'GVM/1', { method: 'GET', headers: { 'Content-Type': 'application/json' , 'Key': 'GridPowerYear' }});  
    
    let GVConsumerDayCall = await fetch(baseUrl + 'consumer', { method: 'GET', headers: { 'ID': '1', 'Content-Type': 'application/json' , 'Key': 'ConsumerDay' }});  
    let GVConsumerWeekCall = await fetch(baseUrl + 'consumer', { method: 'GET', headers: { 'ID': '1', 'Content-Type': 'application/json' , 'Key': 'ConsumerWeek' }});
    let GVConsumerMonthCall = await fetch(baseUrl + 'consumer', { method: 'GET', headers: { 'ID': '1', 'Content-Type': 'application/json' , 'Key': 'ConsumerMonth' }});
    let GVConsumerYearCall = await fetch(baseUrl + 'consumer', { method: 'GET', headers: { 'ID': '1', 'Content-Type': 'application/json' , 'Key': 'ConsumerYear' }});  

     await Promise.all([GVPowerDayCall, GVPowerWeekCall, GVPowerMonthCall, GVPowerYearCall, GVConsumerDayCall, GVConsumerWeekCall, GVConsumerMonthCall, GVConsumerYearCall])    
      .then(([resPDay, resPWeek, resPMonth, resPYear, resCDay, resCWeek, resCMonth, resCYear]) => 
          Promise.all([resPDay.json(), resPWeek.json(), resPMonth.json(), resPYear.json(), resCDay.json(), resCWeek.json(), resCMonth.json(), resCYear.json()]))
      .then(([dataPDay, dataPWeek, dataPMonth, dataPYear, dataCDay, dataCWeek, dataCMonth, dataCYear]) => this.setState({
          GVPowerDay: dataPDay,
          GVPowerWeek: dataPWeek,
          GVPowerMonth: dataPMonth,
          GVPowerYear: dataPYear,
          GVConsumerDay: dataCDay,
          GVConsumerWeek: dataCWeek,
          GVConsumerMonth: dataCMonth,
          GVConsumerYear: dataCYear
      }));
  }

  render() {

    let averageGeneratedDay = (Math.round((this.state.GVPowerDay.value ) * 100) / 100);
    let averageGeneratedWeek = Math.round((this.state.GVPowerWeek.value ) * 100) / 100;
    let averageGeneratedMonth = Math.round((this.state.GVPowerMonth.value ) * 100) / 100;
    let averageGeneratedYear = Math.round(((this.state.GVPowerYear.value )) * 100) / 100;
    let averageConsumedDay = (Math.round(((this.state.GVConsumerDay.value) * 1000) * 100) / 100);
    let averageConsumedWeek = Math.round(((this.state.GVConsumerWeek.value) * 1000) * 100) / 100;
    let averageConsumedMonth = Math.round(((this.state.GVConsumerMonth.value) * 1000) * 100) / 100;
    let averageConsumedYear = Math.round(((this.state.GVConsumerYear.value ) * 1000) * 100) / 100;
   // console.log('ConsumerYear: ' + averageConsumedDay);

    let greenData = [{x: 'Seneste døgn', y: averageGeneratedDay}, {x: 'Seneste uge', y: averageGeneratedWeek}, {x: 'Seneste måned', y: averageGeneratedMonth}, {x: 'Seneste år', y: averageGeneratedYear}];

    let orangeData = [{x: 'Seneste døgn', y: averageConsumedDay}, {x: 'Seneste uge', y: averageConsumedWeek}, {x: 'Seneste måned', y: averageConsumedMonth}, {x: 'Seneste år', y: averageConsumedYear}];

    const {useCanvas} = this.state;
    const BarSeries = useCanvas ? VerticalBarSeriesCanvas : VerticalBarSeries;
    return (
      <div className="graph"> 
        <DesktopBreakpoint>
          <p>Gennemsnitlig mølleproduktion vs. gennemsnitlig forbrug i Hjørring</p>          
            <XYPlot xType="ordinal" width={700} height={300} xDistance={100}>
              
              <HorizontalGridLines />
              <XAxis />
              <YAxis />
              <BarSeries className="vertical-bar-series-example" data={greenData} color="#68974B" />
              <BarSeries data={orangeData} color="#ff0000" />            
            </XYPlot>
            <div className="graph-color-description">
              <div className="green-color-box"></div>
              <p>Gns. kW Produktion</p>
              <div className="orange-color-box"></div>
              <p>Gns. kW Forbrug</p>
            </div>
        </DesktopBreakpoint>

        <TabletBreakpoint>
          <p>Gennemsnitlig mølleproduktion vs. gennemsnitlig forbrug i Hjørring</p>          
            <XYPlot xType="ordinal" width={700} height={300} xDistance={100}>
              
              <HorizontalGridLines />
              <XAxis />
              <YAxis />
              <BarSeries className="vertical-bar-series-example" data={greenData} color="#68974B" />
              <BarSeries data={orangeData} color="#ff0000" />            
            </XYPlot>
            <div className="graph-color-description">
              <div className="green-color-box"></div>
              <p>Gns. kW Produktion</p>
              <div className="orange-color-box"></div>
              <p>Gns. kW Forbrug</p>
            </div>
        </TabletBreakpoint>

        <PhoneBreakpoint>
          <p>Gennemsnitlig mølleproduktion vs. gennemsnitlig forbrug i Hjørring</p>          
            <XYPlot xType="ordinal" width={370} height={300} xDistance={60}>
              
              <HorizontalGridLines />
              <XAxis />
              <YAxis />
              <BarSeries className="vertical-bar-series-example" data={greenData} color="#68974B" />
              <BarSeries data={orangeData} color="#ff0000" />            
            </XYPlot>
            <div className="graph-color-description">
              <div className="green-color-box"></div>
              <p>Gns. MW Produktion</p>
              <div className="orange-color-box"></div>
              <p>Gns. MW Forbrug</p>
            </div>
        </PhoneBreakpoint>

        <SmallPhoneBreakpoint>
          <p>Gennemsnitlig mølleproduktion vs. gennemsnitlig forbrug i Hjørring</p>          
            <XYPlot xType="ordinal" width={350} height={300} xDistance={60}>
              
              <HorizontalGridLines />
              <XAxis />
              <YAxis />
              <BarSeries className="vertical-bar-series-example" data={greenData} color="#68974B" />
              <BarSeries data={orangeData} color="#ff0000" />            
            </XYPlot>
            <div className="graph-color-description">
              <div className="green-color-box"></div>
              <p>Gns. MW Produktion</p>
              <div className="orange-color-box"></div>
              <p>Gns. MW Forbrug</p>
            </div>
        </SmallPhoneBreakpoint>
      </div>
    );
  }
}


// <div class="label-row">
//           <div class="column"><p>{averageGeneratedDay} MW</p></div>
//           <div class="column"><p>{averageGeneratedWeek} MW</p></div>
//           <div class="column"><p>{averageGeneratedMonth} MW</p></div>
//           <div class="column"><p>{averageGeneratedYear} MW</p></div>
//         </div>


// WEBPACK FOOTER //
// ./src/features/home/Graph.js